import {
  setLoader,
  unSetLoader,
  setErrorMessage,
  showSnackbar,
} from "./appActions";
import {
  ADD_DOCUMENT_TAGS,
  SET_ALL_DOCUMENTS,
  SET_PENDING_DOCUMENTS,
} from "./actionTypes";
import getUserName from "store/getUserName";
import {
  getTagsArray,
  getMimeType,
  downloadFile,
  openFileInWindow,
} from "utils/helper";

import { setAdvanceDocumentSearch } from "store/actions";
import { billing } from "store/requests";
import getPracticeId from "store/practiceId";

export const getAllDocuments = () => {
  return async (dispatch, store) => {
    try {
      const payload = {
        type: "Documents",
        search_criteria: {
          practice_id: store().auth.authData?.selected_practice.toString(),
        },
        user_name: getUserName(),
      };
      let { data } = await billing({
        url: "/getDocuments",
        payload,
      });
      dispatch({
        type: SET_ALL_DOCUMENTS,
        documents: data.map((d) => ({
          ...d,
          tags: getTagsArray(d.tags),
        })),
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const getPendingDocuments = () => {
  return async (dispatch, store) => {
    try {
      const payload = {
        type: "Documents",
        search_criteria: {
          practice_id: store().auth.authData?.selected_practice.toString(),
        },
        user_name: getUserName(),
      };
      let { data } = await billing({
        url: "/getPendingDocuments",
        payload,
      });
      dispatch({
        type: SET_PENDING_DOCUMENTS,
        documents: data.map((d) => ({
          ...d,
          tags: getTagsArray(d.tags),
        })),
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const getDocument = (payload, extension = "pdf") => {
  return async (dispatch) => {
    try {
      let response = await billing({
        url: "/getDocument",
        payload,
        addUserName: true,
        data: {
          responseType: "blob",
        },
      });
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: getMimeType(extension) }),
      );
      return url;
    } catch (error) {
      dispatch(showSnackbar(error?.response?.data?.error || error.message));
    }
  };
};

export const updateDocument = (payload, showLoader = true) => {
  return async (dispatch) => {
    try {
      if (showLoader) dispatch(setLoader());
      let { data } = await billing({
        url: "/updateDocument",
        payload,
        addUserName: true,
      });
      if (showLoader) dispatch(unSetLoader());
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
      if (showLoader) dispatch(unSetLoader());
    }
  };
};

export const getDocuments = (payload, setState = false) => {
  return async (dispatch) => {
    try {
      let response = await billing({
        url: "/getDocuments",
        payload,
        addUserName: true,
      });
      if (setState) {
        const data = response.data.map((d) => ({
          ...d,
          tags: getTagsArray(d.tags),
        }));
        dispatch(
          setAdvanceDocumentSearch({
            payload,
            data,
          }),
        );
        return data;
      }
      return response.data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const deleteDocuments = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/deleteDocuments",
        payload,
        addUserName: true,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const uploadDocument = (payload, file) => {
  console.log("file uploadDocument: ", file);
  const data = new FormData();
  data.append("file", file);
  data.append(
    "request_json",
    JSON.stringify({
      ...payload,
      user_name: getUserName(),
      practice_id: getPracticeId(),
    }),
  );

  return async (dispatch) => {
    try {
      let response = await billing({
        url: "/uploadDocument",
        payload: data,
        addPracticeId: false,
      });
      return response.data.status;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const downloadDocument = (payload, filename) => {
  return async (dispatch) => {
    try {
      let response = await billing({
        url: "/getDocument",
        payload,
        addUserName: true,
        data: {
          responseType: "blob",
        },
      });
      const openFile = ["jpg", "png", "jpeg", "pdf"];
      const ext = filename.split(".")[1];
      if (!openFile.includes(ext)) {
        // To download the file : For tiff files //
        downloadFile({ response, filename });
      } else {
        openFileInWindow({ response, ext });
      }
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const deleteFromS3 = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/deleteDocument",
        payload,
        addUserName: true,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    } finally {
      dispatch(unSetLoader());
    }
  };
};

export const assignDocument = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/assignDocument",
        payload,
        addUserName: true,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    } finally {
      dispatch(unSetLoader());
    }
  };
};

export const getDocumentTagsForPractice = () => {
  return async (dispatch) => {
    const payload = {
      type: "Documents",
      practice_id: 1005,
    };

    try {
      let { data } = await billing({
        url: "/getDocumentTagsForPractice",
        payload,
      });

      dispatch({
        type: ADD_DOCUMENT_TAGS,
        payload: data,
      });

      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const getDocumentsByTags = (payload) => {
  return async (dispatch) => {
    try {
      let response = await billing({
        url: "/getDocumentsByTags",
        payload,
      });
      const data = response.data.map((d) => ({
        ...d,
        tags: getTagsArray(d.tags),
      }));
      dispatch(
        setAdvanceDocumentSearch({
          payload,
          data,
        }),
      );
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};
